import * as React from 'react';
import { styled } from '../../theme';
import { PropsWithChildren } from 'react';

export interface DialogContentWidgetProps {
  title?: string;
  subTitle?: string;
  footerContent?: JSX.Element;
  isErrorDialog?: boolean;
}

export const DialogContentWidget: React.FC<PropsWithChildren<DialogContentWidgetProps>> = (props) => {
  const getTitle = () => {
    if (!props.title) {
      return null;
    }
    return <S.Title isError={props.isErrorDialog}>{props.title}</S.Title>;
  };

  const getSubTitle = () => {
    if (!props.subTitle) {
      return null;
    }
    return <S.SubTitle>{props.subTitle}</S.SubTitle>;
  };

  return (
    <S.Container>
      <S.Content>
        {getTitle()}
        {getSubTitle()}
        <S.Children>{props.children}</S.Children>
        <S.Footer>{props.footerContent}</S.Footer>
      </S.Content>
    </S.Container>
  );
};

namespace S {
  export const Container = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    background: ${(p) => p.theme.dialog.background};
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  `;

  export const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px 24px 24px;
    max-width: 600px;
    min-width: 300px;
  `;

  export const Title = styled.div<{ isError?: boolean }>`
    font-size: 24px;
    color: ${(p) => (p.isError ? p.theme.dialog.errorColor : p.theme.text.primary)};
    user-select: none;
  `;

  export const SubTitle = styled.div`
    font-size: 18px;
    color: ${(p) => p.theme.text.secondary};
    padding-top: 6px;
    user-select: none;
  `;

  export const Children = styled.div`
    padding: 16px 0;
  `;

  export const Footer = styled.div`
    align-self: flex-end;
  `;
}
